import Api from "../config/api";

export const findAllGrupoProcedimento = async (variables) => {
  const response = await Api.post("", {
    query: `
      query($search: String, $ativo: Boolean, $pageableDTO: PageableDTOInput) {
        findAllGrupoProcedimento(search: $search, ativo: $ativo, pageableDTO: $pageableDTO) {
          content {
            id
            nome
            ativo
            procedimentos {
              id
              nome
            }
          }
          last
          totalElements
        }
      }
    `,
    variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllGrupoProcedimento;
};

export const findByIdGrupoProcedimento = async (id) => {
  const response = await Api.post("", {
    query: `
      query($id: UUID) {
        findByIdGrupoProcedimento(id: $id) {
          id
          nome
          ativo
          procedimentos {
            id
            nome
          }
        }
      }
    `,
    variables: { id },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findByIdGrupoProcedimento;
};

export const createGrupoProcedimento = async (grupoProcedimento) => {
  const response = await Api.post("", {
    query: `
      query($grupoProcedimento: GrupoProcedimentoInput) {
        createGrupoProcedimento(grupoProcedimento: $grupoProcedimento) {
          id
        }
      }
    `,
    variables: { grupoProcedimento },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.createGrupoProcedimento;
};

export const updateGrupoProcedimento = async (grupoProcedimento) => {
  const response = await Api.post("", {
    query: `
      query($grupoProcedimento: GrupoProcedimentoInput) {
        updateGrupoProcedimento(grupoProcedimento: $grupoProcedimento) {
          id
        }
      }
    `,
    variables: { grupoProcedimento },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.updateGrupoProcedimento;
};
